import React from 'react';
import { useApptekster } from '../contexts/ApptekstContext';
import { Tekster } from '../types/apptekster';
import { SVVStepIndicator } from '@komponentkassen/svv-step-indicator';

type StegveiviserProps = {
    steg: { value: number; text: string }[];
    aktivtSteg: number;
};

export const Stegveiviser: React.FC<StegveiviserProps> = ({
    steg,
    aktivtSteg,
}) => {
    const t = useApptekster();
    return (
        <SVVStepIndicator
            routes={steg.map((s) => ({
                name: `${t(s.text as keyof Tekster)}`,
                active: s.value === aktivtSteg,
            }))}
            ariaLabel="Stegindikator"
        />
    );
};
